// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"f3FXG","icon-wrapper_disabled":"t6GUR"};